import { render, staticRenderFns } from "./FulfillmentShipping.vue?vue&type=template&id=2366f142&"
import script from "./FulfillmentShipping.vue?vue&type=script&lang=js&"
export * from "./FulfillmentShipping.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentShipping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports